import {createSelector} from 'reselect'
import {
    hasEditHierarchyRight,
    hasGenerateMoneyReportsRight,
    hasManageUsersRight,
    hasSubmitOtherUsersTTRight,
    hasManagePtoAndSickDays,
    canAccessAllManagementScope,
    hasSomeTeamAssignment,
    hasManageSystemSettingsRight,
    hasManageLicenseRight
} from '../util/accessRightsUtils'
import {arrayToSet} from '../atUtils'
import {isBTYEnabled, isURAEnabled} from '../features/selectors'

export const getLoggedInUser = state => state.loggedInUser

export const getLoggedInUserId = state => getLoggedInUser(state).id

export const canEditHierarchy = createSelector(
    getLoggedInUser,
    user => hasEditHierarchyRight(user)
)

export const canManageAccountsAndPermissions = createSelector(
    getLoggedInUser,
    user => hasManageUsersRight(user)
)

export const canGenerateMoneyReports = createSelector(
    getLoggedInUser,
    user => hasGenerateMoneyReportsRight(user)
)

export const canSubmitOtherUsersTT = createSelector(
    getLoggedInUser,
    user => hasSubmitOtherUsersTTRight(user)
)

export const canManagePtoAndSickDays = createSelector(
    getLoggedInUser,
    user => hasManagePtoAndSickDays(user)
)

export const hasAccessAllManagementScope = createSelector (
    getLoggedInUser,
    user => canAccessAllManagementScope(user)
)

export const canAccessSomeTeamAssignment = createSelector(
    getLoggedInUser,
    user => hasSomeTeamAssignment(user)
)

export const hasManageScopeRights = createSelector(
    canGenerateMoneyReports,
    canEditHierarchy,
    canManageAccountsAndPermissions,
    canSubmitOtherUsersTT,
    isURAEnabled,
    isBTYEnabled,
    (canGenerateMoneyReports, canEditHierarchy, canManageAccountsAndPermissions, canSubmitOtherUsersTT, isURAEnabled, isBTYEnabled) =>
        canGenerateMoneyReports && (isURAEnabled || isBTYEnabled) || canEditHierarchy || canManageAccountsAndPermissions || canSubmitOtherUsersTT
)

export const getAccessRights = createSelector(
    getLoggedInUser,
    user => arrayToSet(user.accessRights)
)

export const hasPto = createSelector(
    getLoggedInUser,
    (user) => user.pto
)

export const hasSick = createSelector(
    getLoggedInUser,
    (user) => user.sick
)

export const canManageSystemSettings = createSelector(
    getLoggedInUser,
    user => hasManageSystemSettingsRight(user)
)

export const canManageLicense = createSelector(
    getLoggedInUser,
    user => hasManageLicenseRight(user)
)

export const hasEmail = createSelector(
    getLoggedInUser,
    user => user.hasEmail
)



// WEBPACK FOOTER //
// ./web/js/loggedInUser/selectors.js